// Where the explore map should go when a region is selected.
//
// A region's boundary polygon and its geocoded lonlat are both optional: regions
// whose Mapbox geocoding failed or scored too low have neither, and the GraphQL
// field `lonlatCoords` comes back null. Callers must handle `none` by leaving the
// map where it is.
export type RegionMapTarget =
  | { kind: 'polygon'; geoJson: any }
  | { kind: 'center'; center: [number, number] }
  | { kind: 'none' }

export function regionMapTarget(
  region: { lonlatCoords?: number[] | null } | null | undefined,
  geoJson: any,
): RegionMapTarget {
  if (!region) {
    return { kind: 'none' }
  }
  if (geoJson) {
    return { kind: 'polygon', geoJson }
  }
  const coords = region.lonlatCoords
  if (Array.isArray(coords) && coords.length >= 2 && Number.isFinite(coords[0]) && Number.isFinite(coords[1])) {
    return { kind: 'center', center: [coords[0], coords[1]] }
  }
  return { kind: 'none' }
}
